// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-4zvx3fu4v4rsmfwrpemgf1h6k5ppbhzf9q49x262atpdg25nugsqnq64sxju9dx5rxkxgp5d496xrxdk97zaz2huss9xakeeq5tfyyc","loading":"loading-27ztm81njm3amrtg7p5juxqt9r7h49v151144dhbgy5n6869vpkde8ydymtqhdhrhqzjgr8qy4ukbuty9vvdfhq7drj4rjtgru3u2qn","pulse":"pulse-3e5qjjfppjvr6pmkfbjhsndkccxmubrwbsavrumbpy6pddk6w2dhpufmthc8y41527mww8ygs9vq779s58pad5m4ed57j8tvhkvb7zm"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/Home.module.scss
// module id = 1121
// module chunks = 0